import { StandardEvents } from '@shopify/events';

// Consume Horizon's completed selection response; never fetch, price or add to cart.
class AbsenCatalogDetails extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.updateDetails);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.updateDetails);
  }

  updateDetails = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    this.selectionPromise = event.promise;
    event.promise.then(({ detail }) => {
      if (this.selectionPromise !== event.promise) return;
      if (!detail?.html || String(detail.productId) !== this.dataset.productId) return;
      const updated = detail.html.querySelector(`absen-catalog-details[data-block-id="${this.dataset.blockId}"]`);
      const currentBuy = this.section?.querySelector('[data-absen-catalog-buy]');
      const nextBuy = detail.html.querySelector('[data-absen-catalog-buy]');
      // Direct-to-direct stays with Horizon; native morph may consume response nodes.
      // Rebuild only when entering, leaving or updating a quote variant.
      if (currentBuy && nextBuy && (
        currentBuy.dataset.catalogSalesMode === 'Contact for quote' ||
        nextBuy.dataset.catalogSalesMode === 'Contact for quote'
      )) {
        currentBuy.replaceWith(nextBuy.cloneNode(true));
        for (const price of this.section.querySelectorAll('product-price[data-block-id]')) {
          if (price.dataset.productId !== this.dataset.productId) continue;
          const nextPrice = detail.html.querySelector(`product-price[data-block-id="${price.dataset.blockId}"]`);
          if (!nextPrice) continue;
          // Keep product-price connected so its native listener owns the amount.
          // It moves priceContainer out of detail.html before this callback.
          price.querySelectorAll('.tax-note, .installments').forEach((node) => node.remove());
          for (const extra of nextPrice.querySelectorAll('.tax-note, .installments')) {
            price.append(extra.cloneNode(true));
          }
        }
        const sticky = this.section.querySelector('[data-absen-catalog-sticky]');
        const nextSticky = detail.html.querySelector('[data-absen-catalog-sticky]');
        if (sticky && nextSticky) sticky.replaceChildren(...nextSticky.cloneNode(true).childNodes);
      }
      if (updated) {
        this.replaceChildren(...updated.childNodes);
      }
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[absen-catalog-details]', error);
    });
  };
}

if (!customElements.get('absen-catalog-details')) customElements.define('absen-catalog-details', AbsenCatalogDetails);
